import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/wall/u6-enterprise-in-wall.png";
import type { Product } from "../../types";
import { wifiWall } from "../product-list-groups/wifiWall";
import {
  connectedDevices,
  customization,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const u6EnterpriseInWall: Product = {
  id: "u6EnterpriseInWall",
  productTitle: "U6 Enterprise In-Wall",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u6-enterprise-iw"],
  storePathParts: {
    productSlug: "u6-enterprise-iw",
    category: UniFiChildCategorySlug.WiFiWall,
  },
  sku: "U6-Enterprise-IW",
  description: "u6EnterpriseInWall.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6EnterpriseInWall.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u6EnterpriseInWall.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "115 m² (1,250 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "600+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: {
        type: "string",
        value: "(4) GbE with\n(1) PoE out",
      },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+ / PoE++*" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u6EnterpriseInWall.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u6EnterpriseInWall.mounting",
      },
    },
    {
      propertyId: customization.id,
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u6EnterpriseInWall.notes"],
};
